import { endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators/map';

@Injectable()
export class ReportIncomeService {

	constructor(private http: HttpClient) { }

	getYearsReport(): Observable<any> {
		return this.http.get( endpoints.accounts.reportIncomeYears).pipe(map((data: any) => {
			return data.Retorno;
		}));
	};
/*
	getReceiptsList(dateBegin: any, dateEnd: any): Observable<Receipt[]> {

		const beginDate = moment(dateBegin).format('YYYY-MM-DD');
		const endDate = moment(dateEnd).format('YYYY-MM-DD');

		const params = new HttpParams()
			.set('dataInicio', beginDate)
			.set('dataFim', endDate);

		return this.http.get( endpoints.receipts.all, {params}).pipe(map((data: any) => {

			if (data.Sucesso) {

				if (data.Retorno !== undefined ) {
					this.receipt = data.Retorno.map(item => {
						const list = new Receipt();
						const FP = new FormatPricePipe();

						if (item.Favorecido) {
							list.receiptDescription = '- ' + item.Favorecido;
						}
						list.receiptId = item.IdComprovante;
						if (item.TipoComprovante === 'EntreContas') {
							list.receiptLabel = 'Transferência Entre Contas';
						} else if (item.TipoComprovante === 'Convenio') {
							list.receiptLabel = 'Convênio';
						} else {
							list.receiptLabel = item.TipoComprovante;
						}
						list.receiptType = item.TipoComprovante;
						list.date = moment(item.Data).format('DD/MM/YYYY');
						list.value = FP.transform(item.Valor, false);

						return list;
					});
				} else {
					this.receipt = data.Retorno;
				}

			}

			return this.receipt;

		}));
	}


	/*
	getReceiptsDetail(idReceipt: any, typeReceipt: any): Observable<Detail> {

		return this.http.get( endpoints.receipts.detail +
			typeReceipt + '/' + idReceipt ).pipe(map((data: any) => {

			const detail = new Detail();
			const FP = new FormatPricePipe();
			const CP = new CpfCnpjPipe();
			const ANP = new AccountNumberPipe();
			const item = data.Retorno;
			let itemDetalhe;

			if (data.Sucesso) {

				if (data.Retorno.DetalheTED) {
					itemDetalhe = data.Retorno.DetalheTED;
					detail.favBankDescription = itemDetalhe.FavBancoDesc;
					detail.receiptsTitle = 'Comprovante de transferência TED';
					detail.receiptsSubtitle = 'Dados da transferência';
					detail.transferEmitBankDescription = data.Retorno.TitularBanco;
					detail.transferEmitAgency = itemDetalhe.EmitAgencia;
					detail.transferEmitNumberAccount = itemDetalhe.EmitNroConta;
					detail.transferEmitName = data.Retorno.NomeTitular;
				} else if (data.Retorno.DetalheDOC) {
					itemDetalhe = data.Retorno.DetalheDOC;
					detail.favBankDescription = itemDetalhe.FavBancoDesc;
					detail.receiptsTitle = 'Comprovante de transferência DOC';
					detail.receiptsSubtitle = 'Dados da transferência';
					detail.transferEmitBankDescription = data.Retorno.TitularBanco;
					detail.transferEmitAgency = itemDetalhe.EmitAgencia;
					detail.transferEmitNumberAccount = itemDetalhe.EmitNroConta;
					detail.transferEmitName = data.Retorno.NomeTitular;
				} else if (data.Retorno.DetalheBoleto) {
					itemDetalhe = data.Retorno.DetalheBoleto;
					detail.favBankDescription = itemDetalhe.FavBancoDesc;
					detail.receiptsTitle = 'Comprovante de pagamento - Título para outros bancos';
					detail.receiptsSubtitle = 'Dados do boleto';
				} else if (data.Retorno.DetalheEntreContas) {
					itemDetalhe = data.Retorno.DetalheEntreContas;
					detail.receiptsTitle = 'Comprovante de transferência entre contas';
					detail.receiptsSubtitle = 'Dados da transferência';
					detail.transferEmitBankDescription = data.Retorno.TitularBanco;
					detail.favBankDescription = '613 - Omni Banco';
					detail.transferEmitAgency = itemDetalhe.EmitAgencia;
					detail.transferEmitNumberAccount = itemDetalhe.EmitNroConta;
					detail.transferEmitName = data.Retorno.NomeTitular;
				} else if (data.Retorno.DetalheConvenio) {
					itemDetalhe = data.Retorno.DetalheConvenio;
					detail.receiptsTitle = 'Comprovante de pagamento - Convênio';
					detail.receiptsSubtitle = 'Dados do boleto';
				}

				if (itemDetalhe.DtVcto !== undefined) {
					detail.dueDate = moment(itemDetalhe.DtVcto).format('DD/MM/YYYY');
				}
				if (item.DataDebito !== undefined) {
					detail.debitDate = moment(item.DataDebito).format('DD/MM/YYYY');
				}
				if (item.DataHoraTransacao !== undefined) {
					detail.dateTimeTransaction = moment(item.DataHoraTransacao).format('DD/MM/YYYY [as] HH:mm:ss[h]');
				}
				detail.number = item.Numero;
				if (item.Valor !== undefined) {
					detail.value = FP.transform(item.Valor, false);
				}
				if (itemDetalhe.FavCPFCNPJ !== undefined) {
					detail.favCpfCnpj = CP.transform((itemDetalhe.FavCPFCNPJ).trim());
				}

				if (itemDetalhe.CedenteCPFCNPJ !== undefined) {
					detail.assignorCpfCnpj = CP.transform((itemDetalhe.CedenteCPFCNPJ).trim());
				}

				detail.code = item.Codigo;
				detail.complement = item.Complemento;
				detail.autentication = item.Autenticacao;
				detail.favName = itemDetalhe.FavNome;
				detail.favBank = itemDetalhe.FavBanco;
				detail.favAgency = itemDetalhe.FavAgencia;
				detail.favNumberAccount = itemDetalhe.FavNroConta;
				detail.favTypeAccount = itemDetalhe.FavTpConta;
				detail.finalitySPB = itemDetalhe.FinalidadeSPB;
				detail.historic = itemDetalhe.Historico;
				detail.finalityTes = itemDetalhe.FinalidadeTes;
				detail.finalityCompe = itemDetalhe.FinalidadeCompe;
				detail.codeBar = itemDetalhe.CodBarras;
				detail.nameAgreement = itemDetalhe.NmConveniada;
				detail.assignorName = itemDetalhe.CedenteNome;

				if (detail.receiptsTitle === undefined) {
					detail.hasFirstRow = false;
				}

				if (detail.code === 5) {
					detail.isSecuritie = true;
				}

				detail.payerName = Auth.getInstance().getUser().name;
				detail.payerCpfCnpj = CP.transform(Auth.getInstance().getUser().cpf);
				detail.payerAgency = Auth.getInstance().getUser().agency;
				detail.payerAccount = ANP.transform(Auth.getInstance().getUser().accountNumber);

				detail.securitieRebateValue = FP.transform(itemDetalhe.Abatimento, false);
				detail.discountValue = FP.transform(itemDetalhe.Desconto, false);
				detail.taxValue = FP.transform(itemDetalhe.Juros, false);
				detail.fineValue = FP.transform(itemDetalhe.Multa, false);
				detail.chargesValue = FP.transform(itemDetalhe.Encargos, false);
				detail.nominalValue = FP.transform(itemDetalhe.ValorDocumento, false);

				if (
					detail.favName === undefined &&
					detail.favCpfCnpj === undefined &&
					detail.assignorName === undefined &&
					detail.assignorCpfCnpj === undefined &&
					detail.favBankDescription === undefined &&
					detail.favBank === undefined &&
					detail.favAgency === undefined &&
					detail.codeBar === undefined &&
					detail.dueDate === undefined &&
					detail.favNumberAccount === undefined &&
					detail.favTypeAccount === undefined &&
					detail.debitDate === undefined &&
					detail.dateTimeTransaction === undefined &&
					detail.number === undefined &&
					detail.value === undefined &&
					detail.complement === undefined) {
					detail.hasSecondRow = false;
				}

				if (detail.autentication === undefined) {
						detail.hasThirdRow = false;
				}
			}

			return detail;

		}));
	}


	getReceiptPdf(receiptId: number, receiptType: string, fileType: string): Observable<any> {
		return this.http.get(endpoints.receipts.all +
			`/
			${Auth.getInstance().getUser().agency}/
			${Auth.getInstance().getUser().accountNumber}/
			${receiptId}/
			${receiptType}/
			${fileType}/
			download`, {
			}).pipe(map((data: any) => {
				return data.Retorno;
			}));
	}*/


}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/report-income/report-income.service.ts